import styled from 'styled-components';
import {
  cssColorValue,
  cssSpacing,
  IconMore,
  IconProps,
} from '@spotify-internal/encore-web';

const MoreIcon = styled(IconMore)`
  width: ${cssSpacing('base', '24px')};
  height: auto;
  padding-top: 6px;
`;

const Container = styled.div<{
  hasHoverBackground: boolean;
}>`
  width: 36px;
  height: 36px;
  border-radius: 50%;

  &:hover {
    background: ${props =>
      props.hasHoverBackground
        ? cssColorValue('backgroundTintedBase')
        : 'none'};
    cursor: pointer;
  }
`;

interface MoreIconProps extends IconProps {
  hasHoverBackground: boolean;
}

export const StyledMoreIcon = (props: MoreIconProps) => {
  const { hasHoverBackground, ...restProps } = props;

  return (
    <Container hasHoverBackground={hasHoverBackground}>
      <MoreIcon {...restProps} semanticColor="textSubdued" />
    </Container>
  );
};
